import { addOrgan, allOrgans, deleteOrgan, updateOrgan } from '@/utils/request'
import vue from '@/main'

const state = {
  organList: []
}

const mutations = {
  RESET (state) {
    state.organList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allOrgans().then(response => {
        state.organList = response.data
        resolve(state.organList)
      })
    })
  },
  organById ({ commit, state }, id) {
    for (const team of state.organList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state, rootState }, organ) {
    return new Promise((resolve) => {
      updateOrgan(organ).then(() => {
        for (const cur of state.organList) {
          if (cur.id === organ.id && cur.type === organ.type) {
            Object.assign(cur, organ)
            break
          }
        }
        // 更新当前的车间或者门店
        switch (organ.type) {
          case 'WORKSHOP':
            if (organ.code === process.env.VUE_APP_CODE) {
              rootState.user.workshop = organ
              // 更新用户权限
              this.dispatch('user/reloadMyInfo')
            }
            break

          case 'SHOP':
            if (organ.id === rootState.user.shopId) {
              this.dispatch('shop/updateShopInfo')
            }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addOrgan(team).then((response) => {
        state.organList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, organ) {
    return new Promise((resolve) => {
      deleteOrgan(organ).then(() => {
        for (const i in state.organList) {
          if (state.organList[i].id === organ.id && state.organList[i].type === organ.type) {
            state.organList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
